export const routes = {
  // login
  Login: '/app/login',
  LoginForgot: '/app/login/forgot',

  // 注册
  Register: '/app/register',
  RegisterWelcome: '/app/register/welcome',
  RegisterGuide: '/app/register/guide',

  // dashboard
  Dashboard: '/app/dashboard',

  // 房价
  RatesCalendar: '/app/price',
  RatesEdit: '/app/price/bulk-price-editing',

  // 日历
  Calendar: '/app/calendar',

  // 自动化
  Automation: '/app/automation',

  // 任务
  Tasks: '/app/tasks',
  TaskMembers: '/app/tasks/members',

  // 房客
  GuestList: '/app/guests/list',

  // 渠道管理
  ChannelAccount: '/app/connected-accounts/list',

  // 自定义选项
  SettingConfig: '/app/settings/custom-options',
};
